module.exports = __webpack_public_path__ + "static/media/13.68b8d30f.jpg";